import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './auth/AuthProvider';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import AnomaliesList from './pages/AnomaliesList';
import AnomalyDetail from './pages/AnomalyDetail';
import AppDetail from './pages/AppDetail';
import Reports from './pages/Reports';
import InventoryGaps from './pages/InventoryGaps';
import Settings from './pages/Settings';

const App: React.FC = () => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/anomalies" element={<AnomaliesList />} />
            <Route path="/anomalies/:accountId/:region/:anomalyId" element={<AnomalyDetail />} />
            <Route path="/apps/:appId" element={<AppDetail />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/inventory-gaps" element={<InventoryGaps />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </AuthProvider>
  );
};

export default App;
